import { combineReducers } from 'redux';
import checkboxSourceOfIncome from './checkbox-source-of-income';
import submitCorporateBeneficialOwnerActors from './corporate-beneficial-owner-actors';
import corporateInformation from './corporate-information';
import corporateTaxRelations from './corporate-tax-relations';
import countries from './countries';
import dynamics from './dynamics';
import corporateInstitution from './financial-institution';
import form from './form';
import keepAlive from './keep-alive';
import pepRca from './pepRca';
import sourceOfIncome from './source-of-income';
import taxRelations from './tax-relations';
const rootReducer = combineReducers({
  form,
  countries,
  pepRca,
  dynamics,
  sourceOfIncome,
  checkboxSourceOfIncome,
  taxRelations,
  corporateTaxRelations,
  corporateInformation,
  submitCorporateBeneficialOwnerActors,
  corporateInstitution,
  keepAlive
});
export default rootReducer;